import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Button, ButtonProps } from '@roc/ui';

// Standard outlined pill button from the app theme; red/green only recolor it.
// (Previously this swapped in a separate MUI theme, which dropped the platform button styling.)
const useStyles = makeStyles((theme: Theme) => ({
  red: {
    color: theme.palette.error.dark,
    borderColor: theme.palette.error.light,
    '&:hover': {
      borderColor: theme.palette.error.main,
    },
  },
  green: {
    color: theme.palette.success.dark,
    borderColor: theme.palette.success.light,
    '&:hover': {
      borderColor: theme.palette.success.main,
    },
  },
}));

interface CustomButtonProps extends Omit<ButtonProps, 'color'> {
  theme: 'red' | 'green' | 'blue';
}

export const CustomButton = (props: CustomButtonProps) => {
  const { theme, className, variant, ...buttonProps } = props;
  const classes = useStyles();
  return (
    <Button
      {...buttonProps}
      className={clsx(className, theme !== 'blue' && classes[theme])}
      color="primary"
      variant="outlined"
    />
  );
};
